import { baseApi } from "shared/api";
import { Roles } from "../model/casdoor";

export const casdoorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyRoles: builder.query<string[], void>({
      query: () => ({
        url: `casdoor/myroles`,
        method: "GET",
      }),
    }),
    getUserRoles: builder.query<Roles[], string>({
      query: (userId) => ({
        url: `casdoor/roles/${userId}`,
        method: "GET",
      }),
    }),
    updateUserRoles: builder.mutation<any, { userId: string; data: Roles[] }>({
      query: ({ userId, data }) => ({
        url: `casdoor/roles/${userId}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
  }),
});

export const {
  useGetUserRolesQuery,
  useUpdateUserRolesMutation,
  useGetMyRolesQuery,
} = casdoorApi;
